var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDingdanguanli = function SvgDingdanguanli(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "99.702%",
    id: "dingdanguanli_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FB5FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D87EB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#dingdanguanli_svg__a)",
    width: 32,
    height: 32,
    rx: 15
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.218 8.776v1.306c0 .22.175.398.39.398h6.902c.215 0 .39-.178.39-.398l-.001-1.306H21.5c.552 0 1 .624 1 1.393v12.545c0 .768-.448 1.394-1 1.394h-11c-.552 0-1-.626-1-1.394V10.169c0-.769.448-1.393 1-1.393h1.718Zm7.027 8.944h-6.49a.3.3 0 0 0-.3.3v.677a.3.3 0 0 0 .3.3h6.49a.3.3 0 0 0 .3-.3v-.677a.3.3 0 0 0-.3-.3Zm0-3.194h-6.49a.3.3 0 0 0-.3.3v.677a.3.3 0 0 0 .3.3h6.49a.3.3 0 0 0 .3-.3v-.677a.3.3 0 0 0-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.754 7.6c.168 0 .305.14.305.312v1.217a.308.308 0 0 1-.305.312H13.35a.308.308 0 0 1-.306-.312V7.912c0-.173.137-.312.306-.312h5.403Z"
  })))));
};

export default SvgDingdanguanli;